import { RefundForm, RefundPreview, RefundOrder } from '@/api/model/manual-refund'

/** 金额和 ID 始终按十进制字符串传输，避免 JS 浮点数丢失精度。 */
export const validRefundAmount = (value: string): boolean => /^(0|[1-9]\d{0,15})(\.\d{1,2})?$/.test(value) && !/^0(?:\.0{1,2})?$/.test(value)
export const refundRequestNo = (): string => {
    const bytes = new Uint8Array(16)
    window.crypto.getRandomValues(bytes)
    return Array.from(bytes).map(value => ('0' + value.toString(16)).slice(-2)).join('')
}
export const refundCommand = (preview: RefundPreview | null, form: RefundForm, requestNo: string) => {
    if (!preview || preview.mid !== form.mid) throw new Error('用户资料已变化，请重新查询')
    if (!validRefundAmount(form.amount)) throw new Error('金额必须大于零且最多两位小数')
    if (!form.reason.trim() || form.reason.trim().length > 500) throw new Error('请填写退款原因，最多 500 字')
    if (!form.channelId || [14, 36].indexOf(Number(form.channelId)) < 0) throw new Error('请选择付款渠道')
    if (form.cardId) {
        const card = preview.cards.find(item => String(item.id) === form.cardId)
        if (!card) throw new Error('银行卡不属于当前用户')
        return { mid: form.mid, cardId: form.cardId, amount: form.amount, channelId: Number(form.channelId), reason: form.reason.trim(), requestNo }
    }
    if (!/^\d{22}$/.test(form.accountNumber) || !preview.banks.some(bank => String(bank.id) === form.bankId)) throw new Error('请填写 22 位本人账号并选择银行')
    return { mid: form.mid, bankId: form.bankId, accountNumber: form.accountNumber, amount: form.amount, channelId: Number(form.channelId), reason: form.reason.trim(), requestNo }
}
export const canRetryRefund = (order: RefundOrder): boolean => order.status === 'FAILED'
export const refundFinished = (order: RefundOrder): boolean => order.status === 'SUCCESS' && order.accountingState === 'POSTED'
export const csvCell = (value: unknown): string => {
    let text = value == null ? '' : String(value)
    if (/^[=+\-@\s]/.test(text)) text = "'" + text
    return '"' + text.replace(/"/g, '""') + '"'
}

/** HTTP 测试站点也能校验原账号；只保存带随机提交号的摘要，不保存可还原的账号。 */
export const refundAccountHash = (requestNo: string, account: string): string => require('js-sha256').sha256(requestNo + ':' + account)
export const refundAccountMask = (account: string): string => /^\d{22}$/.test(account) ? account.slice(0, 2) + '****' + account.slice(-4) : account
export const refundPendingSnapshot = (command: any, summary: any, accountHash = '') => {
    const safeCommand: any = command.refundId
        ? { refundId: command.refundId, channelId: command.channelId, requestNo: command.requestNo }
        : { mid: command.mid, cardId: command.cardId, bankId: command.bankId, amount: command.amount, channelId: command.channelId, reason: command.reason, requestNo: command.requestNo }
    Object.keys(safeCommand).forEach(key => { if (safeCommand[key] === undefined) delete safeCommand[key] })
    return {
        version: 2, command: safeCommand,
        accountHash: command.accountNumber ? refundAccountHash(command.requestNo, command.accountNumber) : accountHash,
        summary: { mid: summary.mid, amount: summary.amount, realName: summary.realName, accountMask: refundAccountMask(summary.accountMask || ''), channelName: summary.channelName }
    }
}
